'use client';

import { useTranslation } from 'react-i18next';

import {
  DEFAULT_CURRENCIES,
  decimalPlacesMapCrypto,
  decimalPlacesMapMicroCrypto,
  getCurrencyName,
} from '@/helpers/currency';
import { getCurrencyCentsAndCode } from '@/helpers/wallet';
import { ScBonusReceivedTooltip } from './styled';

const FIAT_DECIMALS = 2;

export const formatWagerFreeAmount = (amountCents: number, code: string) => {
  const { amount, currency } = getCurrencyCentsAndCode(
    amountCents,
    code,
    DEFAULT_CURRENCIES
  );
  const decimals =
    decimalPlacesMapCrypto[currency] ??
    decimalPlacesMapMicroCrypto[currency] ??
    FIAT_DECIMALS;

  return {
    amount: amount.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }),
    currency: getCurrencyName(currency),
  };
};

interface WagerFreeCashTooltipProps {
  amountCents: number;
  currency: string;
}

export const WagerFreeCashTooltip = ({
  amountCents,
  currency,
}: WagerFreeCashTooltipProps) => {
  const { t } = useTranslation('common');

  return (
    <ScBonusReceivedTooltip>
      <strong className="title">{t('bonusReceived.wagerFree.title')}</strong>
      <p className="text">
        {t(
          'bonusReceived.wagerFree.text',
          formatWagerFreeAmount(amountCents, currency)
        )}
      </p>
    </ScBonusReceivedTooltip>
  );
};
